/**
 * Utility functions for parsing numbers that may contain comma thousands separators
 */

/**
 * Parses a number string that may contain comma as thousands separator
 * Examples:
 * - "3,456.45" -> 3456.45
 * - "1,234,567.89" -> 1234567.89
 * - "456.45" -> 456.45
 * - "3456" -> 3456
 *
 * @param {string|number} value - The value to parse
 * @returns {number} The parsed number
 */
export const parseFloatWithCommas = (value) => {
  if (typeof value === 'number') {
    return value;
  }

  if (!value) {
    return 0;
  }

  // Convert to string and remove commas used as thousands separators
  const cleanValue = String(value).replace(/,/g, '');

  return parseFloat(cleanValue) || 0;
};

/**
 * Safe parseFloat that handles comma thousands separators
 * This is a drop-in replacement for parseFloat when dealing with formatted numbers
 *
 * @param {string|number} value - The value to parse
 * @returns {number} The parsed number
 */
export const safeParseFloat = (value) => {
  return parseFloatWithCommas(value);
};
